<template>
  <div class="keikaku-container">
    <base-header class="pb-4">
      <div class="row align-items-center py-4">
        <div class="col-lg-12 text-center">
          <h6 class="h2 text-white d-inline-block mb-0">Abriendo Keikaku...</h6>
        </div>
      </div>
    </base-header>

    <div class="container-fluid mt--4">
      <div class="row">
        <div class="col">
          <card>
            <div class="card-body text-center p-5">
              <div class="loading-content">
                <i class="fas fa-spinner fa-spin fa-3x text-primary mb-3"></i>
                <h4>Redirigiendo a Keikaku...</h4>
                <p class="text-muted">Por favor, espera...</p>
              </div>
            </div>
          </card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "KeikakuPage",
  mounted() {
    // Abrir Keikaku directamente en una nueva ventana
    const keikakuUrl = "https://aplicaciones.salvadorvertical.com/Keikaku/Index#eyJuYXZpZ2F0ZUZ1biI6Im9wZW5wYWdlbmFtZSIsInRhcmdldGlkIjoiY3VycmVudCIsIm9iamVjdG5hbWUiOiJQbGFuaWZpY2Fkb3JfRXF1aXBvcyIsInBhZ2VuYW1lIjoiUGdfRGFzaEJvYXJkIiwicGFnZXR5cGVpZCI6Imxpc3QifQ==";
    
    const nuevaVentana = window.open(keikakuUrl, '_blank', 'noopener,noreferrer');
    
    if (!nuevaVentana || nuevaVentana.closed || typeof nuevaVentana.closed === 'undefined') {
      this.$notify({
        type: "warning",
        message: "No se pudo abrir la nueva ventana. Por favor, permite ventanas emergentes para este sitio."
      });
    }
    
    // Redirigir de vuelta a la lista de albaranes
    setTimeout(() => {
      this.$router.push({ name: 'List Albaran' });
    }, 1000);
  }
};
</script>

<style scoped>
.keikaku-container {
  min-height: 100vh;
}

.loading-content {
  padding: 40px 20px;
}

.loading-content h4 {
  margin-top: 20px;
  margin-bottom: 10px;
}

.card-body {
  min-height: 400px;
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
